import React from "react";
import SideBarItem from "./SideBarItem";
import { useLocation } from "react-router-dom";

const SideBar = ({ items }) => {
  const location = useLocation();
  return (
   <div className="bg-[#F9F9F9] h-full rounded-[10px] p-2 overflow-y-auto scrollbar-none [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
      {items.map((item) => {
        const isActive = location.pathname.startsWith(item.link);
        return <SideBarItem key={item.id} item={item} isActive={isActive} />;
      })}
    </div>
  );
};

export default SideBar;
